
      import API from "!../../../Booker.Web/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../Booker.Web/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../Booker.Web/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../Booker.Web/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../Booker.Web/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../Booker.Web/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../Booker.Web/node_modules/css-loader/dist/cjs.js!../../../Booker.Web/node_modules/resolve-url-loader/index.js!../../../Booker.Web/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-4.use[3]!./main.scss";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../Booker.Web/node_modules/css-loader/dist/cjs.js!../../../Booker.Web/node_modules/resolve-url-loader/index.js!../../../Booker.Web/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-4.use[3]!./main.scss";
       export default content && content.locals ? content.locals : undefined;
